module.exports = __webpack_public_path__ + "media/images/application/template/touch-gesture-2fd6a1d24bdcf5355603e0bb4fbe6d6d.svg";